import axiosWrapper, { InterceptorOptions } from './axios-wrapper'

const api = axiosWrapper.create(
  {
    baseURL: '/tracer',
    responseType: 'json',
    headers: {
      'Content-Type': 'application/json',
    },
  },
  InterceptorOptions.defaultErrorInterceptor,
)

export function apiFetchUsage({ start_time, end_time, event_type }) {
  let path = `/user_data?starttime=${start_time}&endtime=${end_time}`
  if (event_type) {
    path += `&eventtype=${event_type}`
  }
  return api.get(path).then((resp) => resp.data)
}

export function fetchUsageMonitorConfig() {
  return api.get('/usage_monitor_config').then((resp) => resp.data)
}
